module.exports = __webpack_public_path__ + "img/info_icon.8404c71b.svg";